import { Injectable } from '@angular/core';

import { RootState } from '@next/core-lib/app';
import { select, Store } from '@ngrx/store';
import { combineLatest, Observable } from 'rxjs';
import { map, skipWhile, take } from 'rxjs/operators';

import { getBarnModuleState } from '../../settings/store/selectors/barn.selector';
import { getFlockModuleState } from '../store/selectors/flock.selectors';

@Injectable({
  providedIn: 'root',
})
export class FlocksGuard {
  constructor(private store: Store<RootState>) {}

  isAllRequiredDataLoaded() {
    return combineLatest([
      this.store.pipe(select(getBarnModuleState)),
      this.store.pipe(select(getFlockModuleState)),
    ]).pipe(map(([barnState, flockState]) => flockState.isLoaded && barnState.isLoaded));
  }

  canActivate(): Observable<boolean> {
    return this.isAllRequiredDataLoaded().pipe(
      skipWhile((result) => !result),
      take(1),
    );
  }
}
